import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

function showNewTimeZone(selectedTimeZone) {
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const defaultTimeZone = 'Europe/Lisbon';

  const allEventHours = document.querySelectorAll('.programming2020Container__main__body__content__item__time--SSR');

  /* eslint-disable no-param-reassign */
  allEventHours.forEach((element) => {
    const rawDate = element.dataset.time;
    const newDate = dayjs.tz(rawDate, defaultTimeZone).tz(selectedTimeZone).format('HH:mm');

    element.innerHTML = `${newDate}`;
  });
  /* eslint-enable no-param-reassign */
}

function listenToTimeZoneChange() {
  const timeZoneSelector = document.querySelector('#timezone');
  if (timeZoneSelector) {
    timeZoneSelector.addEventListener('change', () => {
      showNewTimeZone(timeZoneSelector.value);
    });
  }
}

window.addEventListener('load', () => listenToTimeZoneChange());
